import gql from 'graphql-tag';

export const getUserProfile = gql`
  query getUserProfile {
    getUserProfile {
      profile {
        companyName
        companyEmail
        postcode
        contactNumber
        noCorporateEmail
        corporateEmailVerified
        matchesOrganisations
        firstName
        lastName
        costCenter
        payrollNumber
      }
      contactDetails {
          workPhone    
          unitNumber
          addressLineOne
          addressLineTwo
          stateCode
          postCode
      }
      hasOrganisation
      entity
      permissions
      features
      accessLevel
    }
  }
`;

export const profileSave = gql`
  mutation profileSave($profilePayLoad: ProfilePayLoad!) {
    profileSave(profilePayLoad: $profilePayLoad) {
      companyName
      companyEmail
      postcode
      contactNumber
      noCorporateEmail
      validateEmailUrl
      corporateEmailVerified
      matchesOrganisations
      firstName
      lastName
      costCenter
      payrollNumber
      unitNumber
      addressLineOne
      addressLineTwo
      workPhone
    }
  }
`;

export const getUserOrganisations = gql`
  query getUserOrganisations {
    getUserOrganisations {
      status
      organisations {
        orgId
        organisation
      }
    }
  }
`;

export const updateUserOrganisation = gql`
  mutation updateUserOrganisation($orgId: ID!) {
    updateUserOrganisation(orgId: $orgId) {
      status
    }
  }
`;
